import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import isBefore from "date-fns/isBefore";

import { mapErrorCode } from "src/helpers/api";

import { TRIAL_ACTIVE, TRIAL_INACTIVE } from "../consts";

export default function useTrialInfo() {
  const { t } = useTranslation(["errors"]);
  const { errorFetchTrial, loadingTrial, trial } = useSelector((state) => state.commonTrial);

  const [apiTrialErrors, setApiTrialErrors] = useState([]);

  const hasConfigTrial = trial && !!Object.keys(trial).length && trial?.expired_at !== "" && trial?.started_at !== "";
  const isTrialActive =
    hasConfigTrial && trial?.transaction_status === TRIAL_ACTIVE && isBefore(new Date(), new Date(trial?.expired_at));
  const isTrialInactive = hasConfigTrial && trial?.transaction_status === TRIAL_INACTIVE;
  const isTrialVisible = hasConfigTrial;

  useEffect(() => {
    if (errorFetchTrial.length > 0) {
      const formattedErrors = mapErrorCode(t, errorFetchTrial);
      setApiTrialErrors(formattedErrors);
    }
  }, [errorFetchTrial]);

  return {
    trial,
    loadingTrial,
    apiTrialErrors,
    isTrialActive,
    isTrialInactive,
    isTrialVisible,
    hasConfigTrial,
    isOldTrial: new Date(trial?.started_at) < new Date("2023-02-24 09:00:00")
  };
}
